import React from "react";
import { Button, Chip, Avatar, Box } from "@material-ui/core";
import BusinessIcon from "@material-ui/icons/Business";
import { formatPhoneNumber } from "../../utils/formatPhoneNumber";
import { ErpDialogShell, ErpHeroHeader } from "../ErpDialog/ErpDialogShared";
import ErpCompactInfo from "../ErpDialog/ErpCompactInfo";
import erpClientDisplayName, {
  erpClientPersonName
} from "../../utils/erpClientDisplayName";

const formatErpPhone = (phoneNumber) => {
  if (!phoneNumber) return "";
  const cc = phoneNumber.countryCode || "";
  const pn = phoneNumber.phoneNumber || "";
  if (phoneNumber.formatted) return phoneNumber.formatted;
  if (cc && pn) return formatPhoneNumber(`${cc}${pn}`);
  return "";
};

const ErpClientInfoDialog = ({ open, onClose, cliente }) => {
  if (!cliente) return null;

  const displayName = erpClientDisplayName(cliente);
  const personName = erpClientPersonName(cliente);
  const location = [cliente.municipio?.municipioNombre, cliente.departamento?.departamentoNombre]
    .filter(Boolean)
    .join(", ");

  const initials = displayName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

  const fields = [
    ...(personName && personName !== displayName
      ? [{ label: "Nombre", value: personName }]
      : []),
    { label: "Código", value: cliente.codigo },
    { label: "Teléfono", value: formatErpPhone(cliente.phoneNumber) },
    { label: "Email", value: cliente.email },
    { label: "Cédula", value: cliente.cedula },
    { label: "RUC", value: cliente.ruc },
    { label: "Ubicación", value: location },
    { label: "Sucursal", value: cliente.sucursalSede?.name }
  ];

  const chips = [];
  if (cliente.permiteCredito) {
    chips.push(
      <Chip key="credito" label="Permite crédito" size="small" color="primary" variant="outlined" />
    );
  }
  if (cliente.clasificaciones?.length) {
    cliente.clasificaciones.forEach((c) => {
      chips.push(<Chip key={c.id} label={c.name} size="small" />);
    });
  }

  return (
    <ErpDialogShell
      open={open}
      onClose={onClose}
      title="Cliente ERP"
      subtitle={cliente.codigo ? `Código ${cliente.codigo}` : undefined}
      icon={<BusinessIcon color="primary" fontSize="large" />}
      actions={
        <Button onClick={onClose} color="primary" variant="contained">
          Cerrar
        </Button>
      }
    >
      <ErpHeroHeader
        title={displayName}
        chips={chips.length > 0 ? chips : undefined}
      >
        <Box display="flex" alignItems="center" style={{ gap: 12, marginTop: 10 }}>
          <Avatar
            style={{
              width: 44,
              height: 44,
              backgroundColor: "#4A90E2",
              fontWeight: 600,
              fontSize: "1rem"
            }}
          >
            {initials || "?"}
          </Avatar>
        </Box>
      </ErpHeroHeader>

      <ErpCompactInfo fields={fields} />
    </ErpDialogShell>
  );
};

export default ErpClientInfoDialog;
